import {
	ContentContainer,
	ContentDesctiption,
	ContentBox,
	ContentTitle,
	ContentWrapper,
	ImageBox
} from './ContentStyled';
import payline_1 from '../assets/paylines/payline-1.png';
import payline_2 from '../assets/paylines/payline-2.png';
import payline_3 from '../assets/paylines/payline-3.png';
import payline_4 from '../assets/paylines/payline-4.png';
import payline_5 from '../assets/paylines/payline-5.png';
import payline_6 from '../assets/paylines/payline-6.png';
import payline_7 from '../assets/paylines/payline-7.png';
import payline_8 from '../assets/paylines/payline-8.png';
import payline_9 from '../assets/paylines/payline-9.png';
import payline_10 from '../assets/paylines/payline-10.png';
import { TEXTS } from '../helpers/content';

const PAYLINES = [
	payline_1,
	payline_2,
	payline_3,
	payline_4,
	payline_5,
	payline_6,
	payline_7,
	payline_8,
	payline_9,
	payline_10
];

export default function Paylines({ dimentions }) {
	return (
		<ContentWrapper scale={dimentions.scale}>
			<ContentContainer>
				<div style={{ margin: 'auto' }}>
					<ContentTitle scale={dimentions.scale}>
						{TEXTS.paylines[0].title}
					</ContentTitle>
					<ContentDesctiption scale={dimentions.scale}>
						{TEXTS.paylines[0].desc}
					</ContentDesctiption>
				</div>
			</ContentContainer>
			<ContentBox style={{ gap: '1vw' }}>
				{Array(PAYLINES.length)
					.fill()
					.map((_, id) => (
						<ImageBox key={id} name={'payline'}>
							<img src={PAYLINES[id]} alt='payline' />
						</ImageBox>
					))}
			</ContentBox>
		</ContentWrapper>
	);
}
